"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PodioError_1 = __importDefault(require("./PodioError"));
class PodioGoneError extends PodioError_1.default {
    /**
     *
     * @param {string} message
     */
    constructor(message, response, statusCode = 0) {
        super(message, response, statusCode);
        this.message = message;
        this.response = response;
        this.statusCode = statusCode;
        this.name = this.constructor.name;
    }
}
exports.default = PodioGoneError;
